import React, { useState, useEffect } from 'react';
import { fetchEmployeeReviews } from '../api/reviews';
import './ReviewsModal.css';

export default function ReviewsModal({ isOpen, onClose, employeeSub, employeeName }) {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [avg_star_rating, setAvgRating] = useState(null);
    
    useEffect(() => {
        if (isOpen && employeeSub) {
            console.log('Loading reviews for employee sub:', employeeSub, 'Name:', employeeName);
            loadReviews();
        } else if (isOpen && !employeeSub) {
            console.error('No employee sub provided for reviews modal');
            setError('No employee selected');
        }
    }, [isOpen, employeeSub, employeeName]);

    const loadReviews = async () => {
        try {
            setLoading(true);
            setError(null);
            setReviews([]); // Clear previous reviews
            
            console.log('Fetching reviews for sub:', employeeSub);
            const data = await fetchEmployeeReviews(employeeSub);
            console.log('Received reviews data:', data);
            setAvgRating(data.avg_star_rating,0)
            setReviews(data.reviews || []);
        } catch (err) {
            console.error('Error loading reviews:', err);
            setError(`Failed to load reviews: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    const renderStars = (rating) => {
        const numRating = {
            "ONE": 1, "TWO": 2, "THREE": 3, "FOUR": 4, "FIVE": 5
        }[rating] || 0;
        
        return '★'.repeat(numRating) + '☆'.repeat(5 - numRating);
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Reviews for {employeeName} </h3>
                    <button className="close-button" onClick={onClose}>×</button>
                </div>
                
                <div className="modal-body">
                    {loading ? (
                        <div className="loading">Loading reviews for {employeeName}...</div>
                    ) : error ? (
                        <div className="error">
                            {error}
                            <br />
                            {/* <small>Employee Sub: {employeeSub}</small> */}
                        </div>
                    ) : reviews.length === 0 ? (
                        <div className="no-reviews">
                            No reviews found for {employeeName}.
                            <br />
                            {/* <small>Employee Sub: {employeeSub}</small> */}
                        </div>
                    ) : (
                        <div className="review-list">
                            <div className="reviews-summary">
                                Found {reviews.length} review(s) for {employeeName}
                                  <div className="overall-rating">
                                 Overall Rating: ({avg_star_rating.toFixed(1)})
                                    </div>
                            </div>
                            {reviews.map((review, index) => (
                                <div key={review.id || index} className="review-items">
                                    <div className="review-header">
                                          <div className="reviewer-info">
                                            <div className="reviewer-name">{review.reviewer_name}</div>
                                            {review.reviewer_email && (
                                                <div className="reviewer-email">{review.reviewer_email}</div>
                                            )}
                                        </div>
                                        <div className="review-rating">
                                            <span className="stars">{renderStars(review.rating)}</span>
                                            <span className="rating-text">({review.rating})</span>
                                        </div>
                                        <div className="review-date">{review.date}</div>
                                    </div>
                                    <div className="review-text">{review.text}</div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

